import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TETCDataGetListReq,
  TETCDataGetListRes,
  TKohoZyomuinPutReq,
  TETCDataPostReq,
  T高速料,
} from "./TEtc"

/**
 * ETC取込に対するAPIリクエスト用サービス
 *
 * @export
 * @class ETCService
 * @extends {ConnectApi}
 */
export default class ETCService extends ConnectApi {
  /**
   * ETC取込 一覧取得
   *
   * @param {TETCDataGetListReq} params
   * @param {(param: TApiResponse<TETCDataGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TETCDataGetListRes>) => any} reject
   * @memberof ETCService
   */
  getList = async (params: TETCDataGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TETCDataGetListRes[]>> =
        await this.getInner(`/truckcontrol/etcdata`, params)
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 高速料 一覧取得
   *
   * @param {TETCDataGetListReq} params
   * @param {(param: TApiResponse<TETCDataGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TETCDataGetListRes>) => any} reject
   * @memberof ETCService
   */
  getKosokuryoList = async (params: TETCDataGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<T高速料[]>> = await this.getInner(
        `/truckcontrol/etckosokuryo`,
        params
      )
      return res.data
      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * ETC取込 更新
   *
   * @param {TKohoZyomuinPutReq} data
   * @param {(param: TApiResponse<TETCDataGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TETCDataGetListRes[]>>) => any} reject
   * @memberof ETCService
   */
  put = async (data: TKohoZyomuinPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/etcdatatorikomi`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * ETC紐づけ
   *
   * @param {TKohoZyomuinPutDeleteReq} data
   * @param {(param: TApiResponse<TETCDataGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TETCDataGetListRes[]>>) => any} reject
   * @memberof ETCService
   */
  putEtcHimoduke = async (id: string, data: { 乗務員ID: number }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/etcdata/actions/etchimoduke/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * ETC紐づけリスト
   *
   * @param {TKohoZyomuinPutDeleteReq} data
   * @param {(param: TApiResponse<TETCDataGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TETCDataGetListRes[]>>) => any} reject
   * @memberof ETCService
   */
  putEtcHimodukeList = async (data: {
    年月: string
    高速料InfoList: { 高速料ID: number; 更新日時: string }[]
  }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/etcdata/actions/etchimodukelist/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * ETC紐づけ削除
   *
   * @param {TKohoZyomuinPutDeleteReq} data
   * @param {(param: TApiResponse<TETCDataGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TETCDataGetListRes[]>>) => any} reject
   * @memberof ETCService
   */
  deleteHimoduke = async (id: string, data: { 乗務員ID: number }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/etcdata/actions/deletehimoduke/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * ETC紐づけ削除
   *
   * @param {TKohoZyomuinPutDeleteReq} data
   * @param {(param: TApiResponse<TETCDataGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TETCDataGetListRes[]>>) => any} reject
   * @memberof ETCService
   */
  putDelete = async (乗務員id: number) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/etcdatatorikomi`,
        乗務員id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TETCDataPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TETCDataPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `truckcontrol/etcdata`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}
